export enum MarpolPollutionCategoryEnum {
    Unknown,
    X,
    Y,
    Z,
    OS
}
